"use client";
import { ReactNode } from "react";
import useFeatureFlag from "./hooks/useFeatureFlag";
import { FlagMap, FeatureFlagResolverProps } from "./types";

export function FeatureFlagComponentResolverClient<K extends keyof FlagMap>({
  flagKey,
  fallback,
  variants,
}: FeatureFlagResolverProps<K>): ReactNode {
  const { flagValue, isLoading } = useFeatureFlag(flagKey, fallback);

  // Show nothing while loading to prevent flicker
  if (isLoading) {
    return null;
  }

  // If the flag value exists and there is a corresponding variant, render it
  if (flagValue && variants[flagValue]) {
    return variants[flagValue];
  }

  // If there is a fallback value and there is a corresponding variant, render it
  if (fallback && variants[fallback]) {
    return variants[fallback];
  }

  return null;
}
